import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { combineLatest, iif, of } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { StateFacade as OverviewFacade } from '../../facades/state.facade';
import {
  FutureActivityDisabled,
  FutureActivityRequest
} from '../../models/api/future-activities.interfaces';
import { DataLayerAnalyticsService } from '../../services/analytics/data-layer.service';
import { FutureActivityService } from '../../services/api/future-activities.service';
import * as OverviewActions from '../actions/api.actions';

@Injectable()
export class FutureActivityEffects {
  loadActivityData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OverviewActions.loadFutureActivity),
      switchMap(() =>
        combineLatest([
          this.overview.futureActivityRequest$.pipe(
            filter((payload) => payload && Object.keys(payload).length > 0),
            take(1)
          ),
          this.overview.flags$.pipe(
            filter((flag) => !!flag?.overview.tracker),
            take(1)
          )
        ]).pipe(
          switchMap(([payload, flag]) =>
            iif(
              () => 'disabled' in payload,
              of(
                OverviewActions.loadFutureActivitySuccess({
                  futureActivities: {
                    id: 'future-activity-content',
                    futureActivityContent: payload as FutureActivityDisabled
                  }
                })
              ),
              this.futureActivity
                .getFutureActivities(
                  payload as FutureActivityRequest,
                  flag?.trackerApi
                )
                .pipe(
                  filter((content) => !!content),
                  switchMap((content) => [
                    OverviewActions.loadFutureActivitySuccess({
                      futureActivities: {
                        id: 'future-activity-content',
                        futureActivityContent: content
                      }
                    })
                  ])
                )
            )
          )
        )
      ),
      catchError((error: HttpErrorResponse) => {
        this.dataLayer.setErrorData(error);
        return of(
          OverviewActions.loadFutureActivityFailure({
            error: {
              id: 'future-activity-content-error',
              futureActivityContentError: 'future-activity'
            }
          })
        );
      })
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly futureActivity: FutureActivityService,
    private readonly overview: OverviewFacade,
    protected dataLayer: DataLayerAnalyticsService
  ) {}
}
